// Build My Routine product classification.
// Loaded after helpers and before build-my-routine.js.

function classifyMakeupCategory(product) {
  if (product.slot !== 'makeup') return null;

  const title = (product.title || '').toLowerCase();
  const type = (product.type || '').toLowerCase();
  const typeMeta = (product.product_type_meta || '').toLowerCase();

  if (type === 'mascara' || typeMeta === 'mascara' || /\bmascara\b|\blash\b/.test(title)) {
    return 'mascara';
  }

  if (
    type === 'lipstick' ||
    typeMeta === 'lipstick' ||
    /\blip\s*(stick|gloss|tint|liner|plumper|shine)\b|\blip\s*balm\b/.test(title)
  ) {
    return 'lip';
  }

  if (
    type === 'blush' ||
    typeMeta === 'blush' ||
    /\bblush\b|\bcheek\s*(colou?r|tint|stick|balm)\b/.test(title) ||
    /\btotal\s+protection[\u2122\u00ae\s]*color\s*balm\b/.test(title)
  ) {
    return 'balm';
  }

  if (/\bpalette\b|\beye\s*&\s*brow\b|\bcorrector\b|\beyeshadow\b|\bhighlighter\b|\bbronzer\b/.test(title)) {
    return 'palette';
  }

  if (type === 'foundation' || typeMeta === 'foundation' || /\bfoundation\b|\bconcealer\b/.test(title)) {
    return 'foundation';
  }
  if (
    type === 'setting spray' ||
    typeMeta === 'setting spray' ||
    /\b(setting spray|setting mist|hydrating mist|finishing spray|fixing spray)\b/.test(title)
  ) {
    return 'setting_spray';
  }
  return 'other';
}

function classifyProductSlot(product) {
  // custom.product_type / product_type_meta is the preferred source of truth
  // for routine slot classification. Shopify product.type, tags, and title
  // matching are kept as fallback safety nets only.
  const title = (product.title || '').toLowerCase();
  const type = (product.type || '').toLowerCase();
  const typeMeta = (product.product_type_meta || '').toLowerCase();
  const tags = (product.tags || []).map((t) => t.toLowerCase());
  const rp = product.routine_preference;
  // Safety gate: only Face Care and Baby Care products can enter the routine builder.
  // This blocks Hair Care, Body Care, Gift Cards, Jewellery, Deodorants, etc.
   if (type !== 'face care' && type !== 'baby care') {
     return null;
   }

  const hasTypeMeta = (s) => typeMeta.includes(s);
  const titleMatch = (re) => re.test(title);
const typeMetaSlug = normalizeValue(typeMeta);
const typeMetaTokens = typeMetaSlug.split('_').filter(Boolean);

if (
  titleMatch(/\b(set|sets|kit|kits|bundle|bundles|routine kit|starter kit|program)\b/i) ||
  typeMetaTokens.some((token) =>
    ['set', 'sets', 'kit', 'kits', 'bundle', 'bundles', 'program'].includes(token)
  )
) {
  return null;
}
  const isTintedSkincare =
    hasTypeMeta('tinted moisturiser') ||
    hasTypeMeta('tinted moisturizer') ||
    hasTypeMeta('tinted sunscreen') ||
    hasTypeMeta('tinted sun');

  const isMakeupRemover =
    type === 'makeup remover' ||
    hasTypeMeta('makeup remover') ||
    titleMatch(/\b(makeup remover|make-up remover|cleansing oil|cleansing water)\b/);

  const isColorBalm = titleMatch(/\btotal\s+protection[\u2122\u00ae\s]*color\s*balm\b/);
  const isLipGloss = titleMatch(/\blip\s*(gloss|tint|shine|plumper)\b/);
    const isSettingSpray =
    type === 'setting spray' ||
    hasTypeMeta('setting spray') ||
    titleMatch(/\b(setting spray|setting mist|hydrating mist|finishing spray|fixing spray)\b/);

  const isMakeupFoundation =
    titleMatch(/\b(natural\s+pressed|mineral\s+pressed|pressed\s+mineral|loose\s+mineral|liquid\s+mineral)\s+foundation\b/) ||
    (titleMatch(/\bfoundation\b/) && !titleMatch(/\btinted\s+(moisturi[sz]er|sunscreen)\b/));

    if (!isMakeupRemover && (isColorBalm || isLipGloss || isMakeupFoundation || isSettingSpray)) {
    return 'makeup';
  }

if (!isTintedSkincare && !isMakeupRemover && (
  type === 'makeup' || hasTypeMeta('makeup') ||
  type === 'foundation' || hasTypeMeta('foundation') ||
  type === 'concealer' || hasTypeMeta('concealer') ||
  type === 'lipstick' || hasTypeMeta('lipstick') ||
  type === 'mascara' || hasTypeMeta('mascara') ||
  type === 'eyeshadow' || hasTypeMeta('eyeshadow') ||
  type === 'blush' || hasTypeMeta('blush') ||
  type === 'bronzer' || hasTypeMeta('bronzer') ||
  type === 'palette' || hasTypeMeta('palette') ||
  type === 'corrector palette' || hasTypeMeta('corrector palette') ||
  hasTypeMeta('corrector') ||
  hasTypeMeta('lip gloss') || hasTypeMeta('lip tint') ||
  tags.some((t) => t === 'makeup')
)) {
  return 'makeup';
}

  if (titleMatch(/\bbaby\s+oil\b|\bmassage\s+oil\b/)) {
    return 'oil';
  }

  const rejectEye =
    titleMatch(/\btotal\s*eye\b/) ||
    titleMatch(/\beye\s+(cream|contour|repair|complex|therapy|gel|concentrate|firm|wrinkle|serum|masks?|hydrogel)/) ||
    titleMatch(/\bperi[- ]?orbital\b/);

  const rejectLip =
    titleMatch(/\blip\s+(balm|baume|treatment|wrinkle|mask|gloss|tint|care|therapy|cream|concentrate)\b/);

const isPaediatricProduct =
  product.age_category_labels &&
  product.age_category_labels.includes(AGE_BUTTON_TO_LABEL['0-12']);

const paediatricCleanser =
  isPaediatricProduct &&
  (
    type === 'body wash' ||
    hasTypeMeta('body wash') ||
    hasTypeMeta('bath & shower') ||
    hasTypeMeta('bath and shower') ||
    hasTypeMeta('baby care') ||
    titleMatch(/\b(baby\s+(wash|bath)|cleansing gel|wash gel|body wash)\b/)
  );

const rejectBody =
  titleMatch(/\bbody\s+(lotion|cream|oil|wash|mist|spray|shield|glow|scrub|butter)\b/) ||
  titleMatch(/\b(chest rub|nappy|cradle cap|bubble bath|shampoo|conditioner|hair mask|scalp|anti-hair loss|deodorant|anti-perspirant|antiperspirant|hand cream)\b/) ||
  titleMatch(/\bbaby\s+(oil|lotion|wash|bath|cream|shampoo)\b/);

if (rejectEye || rejectLip || (rejectBody && !paediatricCleanser)) return null;

if (paediatricCleanser) return 'cleanser';

  if (!isTintedSkincare) {
    const rejectByType =
  type === 'eye cream' ||
  type === 'body care' ||
  type === 'hair care' ||
  type === 'body mist' ||
  type === 'body wash' ||
  type === 'shampoo' ||
  type === 'conditioner' ||
  type === 'hair mask' ||
  type === 'scalp treatment' ||
  type === 'deodorant' ||
  type === 'anti-perspirant' ||
  type === 'antiperspirant' ||
  type === 'gift card' ||
  type === 'jewellery';

const rejectByMeta =
  hasTypeMeta('eye care') ||
  hasTypeMeta('eye cream') ||
  hasTypeMeta('lip care') ||
  hasTypeMeta('body care') ||
  hasTypeMeta('body moisturiser') ||
  hasTypeMeta('body wash') ||
  hasTypeMeta('bath & shower') ||
  hasTypeMeta('bath and shower') ||
  hasTypeMeta('shampoo') ||
  hasTypeMeta('conditioner') ||
  hasTypeMeta('hair care') ||
  hasTypeMeta('hair mask') ||
  hasTypeMeta('scalp') ||
  hasTypeMeta('anti-hair loss') ||
  hasTypeMeta('anti hair loss') ||
  hasTypeMeta('deodorant') ||
  hasTypeMeta('anti-perspirant') ||
  hasTypeMeta('antiperspirant') ||
  hasTypeMeta('supplement') ||
  hasTypeMeta('gift card') ||
  hasTypeMeta('jewellery') ||
  hasTypeMeta('mask');

    if (rejectByType || rejectByMeta) return null;
  }

  if (
    hasTypeMeta('kit') ||
    hasTypeMeta('treatment kit') ||
    hasTypeMeta('set') ||
    tags.some((t) => t === 'skincare-six' || /(kit|set|bundle|pack|trio|program)/.test(t)) ||
    titleMatch(/\b(set|kit|trio|bundle|pack|program)\b/) && !titleMatch(/\b(patch|peel pads?|exfoliating pads?)\b/)
  ) {
    return 'bundle';
  }

  if (
    type === 'sunscreen' ||
    hasTypeMeta('sunscreen') ||
    hasTypeMeta('sun protection') ||
    hasTypeMeta('tinted sunscreen') ||
    titleMatch(/\bspf\b|\bsun (?:lotion|cream|spray|fluid|screen|forgettable)\b|anthelios|heliocare|sunforgettable/)
  ) {
    return 'sunscreen';
  }

  if (
    type === 'cleanser' ||
    type === 'cleansing wipes' ||
    hasTypeMeta('cleanser') ||
    titleMatch(/\b(cleans(?:er|ing|e)|face wash|micellar|foaming gel|purifying gel|rinse)\b/)
  ) {
    return 'cleanser';
  }

  if (
    hasTypeMeta('exfoliating pads') ||
    hasTypeMeta('exfoliant') ||
    type === 'exfoliating pads' ||
    titleMatch(/\b(peel pads?|microdermabrasion|polish|exfoliating pads?)\b/)
  ) {
    return null;
  }
  if (
    rp === 'pm_only' &&
    (
      type === 'moisturiser' ||
      type === 'moisturizer' ||
      type === 'cream' ||
      hasTypeMeta('moisturiser') ||
      hasTypeMeta('moisturizer') ||
      hasTypeMeta('cream') ||
      titleMatch(/\b(night cream|pm cream|overnight cream|face cream)\b/)
    )
  ) {
    return 'night_cream';
  }

  if (
    type === 'skincare serum' ||
    hasTypeMeta('serum') ||
    titleMatch(/\bserum\b|\bconcentrate\b|\bessence\b|\bampoule\b/)
  ) {
    return 'serum';
  }

  if (
    type === 'moisturiser' ||
    type === 'cream' ||
    hasTypeMeta('moisturiser') ||
    hasTypeMeta('cream') ||
    hasTypeMeta('tinted moisturiser') ||
    titleMatch(/\b(moisturi[sz]er|day cream|balm|face cream|hydrating lotion)\b/) ||
    titleMatch(/\blotion\b/) && !titleMatch(/\bglycolic|aha|bha|retin/)
  ) {
    if (rp === 'pm_only') return 'night_cream';
    return 'moisturiser';
  }

  if (type === 'treatment' || hasTypeMeta('treatment')) {
    return 'serum';
  }

  if (type === 'face care' || type === 'toner' || hasTypeMeta('toner')) {
    return 'serum';
  }

  return null;
}

console.log('[BuildMyRoutine] classification loaded');